import React, { useState, useEffect } from 'react';
import { Medal, Avatar, TrendPill, SectionHeader } from './primitives';

// Ranked staff with medals, avatars, growing bars and trend pills. The gamified
// centrepiece. rows: [{ id, name, value, valueNum, sub, trend:{value}, badge }]
export const Leaderboard = ({ title, subtitle, rows = [], highlightTopThree = true, onRowClick, action, collapsedCount = 6 }) => {
  const top = rows[0] ? rows[0].valueNum : 1;
  const [grown, setGrown] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? rows : rows.slice(0, collapsedCount);
  const canExpand = rows.length > collapsedCount;
  useEffect(() => {
    setGrown(false);
    const r = requestAnimationFrame(() => setGrown(true));
    return () => cancelAnimationFrame(r);
  }, [rows]);

  return (
    <div className="cd-card">
      <SectionHeader title={title} subtitle={subtitle} action={action} />
      {rows.length === 0 ? (
        <p className="cd-empty">No data in this period.</p>
      ) : (
        <>
        <div className="cd-lb-list">
          {visible.map((r, i) => {
            const rank = i + 1;
            const isTop = highlightTopThree && rank === 1;
            const pct = Math.max(4, Math.round((r.valueNum / (top || 1)) * 100));
            const Row = onRowClick ? 'button' : 'div';
            return (
              <Row
                key={r.id || r.name}
                type={onRowClick ? 'button' : undefined}
                className={`cd-lb-row ${isTop ? 'cd-lb-row--top' : ''}`}
                onClick={onRowClick ? () => onRowClick(r) : undefined}
                style={{ animationDelay: `${i * 45}ms` }}
              >
                <span className="cd-lb-id">
                  <Medal rank={rank} />
                  <Avatar name={r.name} size="sm" />
                  <span style={{ minWidth: 0 }}>
                    <span className="cd-lb-name">{r.name}{r.badge && <span className="cd-lb-badge">{r.badge}</span>}</span>
                    {r.sub && <div className="cd-lb-sub">{r.sub}</div>}
                  </span>
                </span>
                <span className="cd-lb-barwrap">
                  <span className="cd-lb-bar"><span className="cd-lb-bar-fill" style={{ width: grown ? `${pct}%` : '0%' }} /></span>
                </span>
                <span className="cd-lb-val">
                  <div className="cd-lb-value">{r.value}</div>
                  {r.trend && <div className="cd-lb-trend"><TrendPill value={r.trend.value} /></div>}
                </span>
              </Row>
            );
          })}
        </div>
        {canExpand && (
          <button type="button" className="cd-lb-more" onClick={() => setExpanded((e) => !e)}>
            {expanded ? 'Show fewer' : `Show all ${rows.length} team members`}
          </button>
        )}
        </>
      )}
    </div>
  );
};
